module.exports = __webpack_public_path__ + "img/elichain_photo.0f9d9cb2.jpg";